import { useState } from 'react';

type Theme = 'light' | 'dark';

const MODUS_THEME_ATTRIBUTES = {
  light: {
    theme: 'modus-modern-light',
    mode: 'light',
  },
  dark: {
    theme: 'modus-modern-dark',
    mode: 'dark',
  },
};

const setHtmlTheme = (theme: 'light' | 'dark') => {
  const html = document.documentElement;
  html.setAttribute('data-theme', MODUS_THEME_ATTRIBUTES[theme].theme);
  html.setAttribute('data-mode', MODUS_THEME_ATTRIBUTES[theme].mode);
  html.classList.remove('light', 'dark');
  html.classList.add(MODUS_THEME_ATTRIBUTES[theme].mode);
};

export const useTheme = () => {
  const [theme, setTheme] = useState<Theme>('light');

  return {
    theme,
    updateTheme: (newTheme: Theme) => {
      setTheme(newTheme);
      setHtmlTheme(newTheme);
    },
  };
};
